import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field"]

  connect() {
    this.refresh()
  }

  refresh() {
    const fieldsById = {}
    this.fieldTargets.forEach((field) => { fieldsById[field.dataset.customFieldId] = field })
    const visibilities = {}
    const visible = (field) => {
      const id = field.dataset.customFieldId
      if (id in visibilities) return visibilities[id]
      if (!field.dataset.parentId) return (visibilities[id] = true)

      const parent = fieldsById[field.dataset.parentId]
      visibilities[id] = Boolean(parent) && visible(parent) && this.selectedOptionIds(parent).includes(field.dataset.triggerOptionId)
      return visibilities[id]
    }
    this.fieldTargets.forEach((field) => this.toggle(field, visible(field)))
  }

  selectedOptionIds(field) {
    const checked = [...field.querySelectorAll("input:checked")].map((input) => input.value)
    const selected = [...field.querySelectorAll("select")].flatMap((select) => [...select.selectedOptions].map((option) => option.value))
    return checked.concat(selected).filter((value) => value !== "")
  }

  toggle(field, visible) {
    field.hidden = !visible
    field.querySelectorAll("input, select, textarea").forEach((input) => { input.disabled = !visible })
  }
}
